import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { focusDone } from '../redux/actionCreators';
import { getIsFocusRequested } from '../redux/selectors';
/**
 * A Comment specific callback that we pass to `DaEditor's` `onEditorReady` prop.
 */
export function useCommentDaEditorReadyHandler(editorId, autoFocus) {
    var dispatch = useDispatch();
    var isFocusRequested = useSelector(partialRight(getIsFocusRequested, editorId, autoFocus));
    return useCallback(function (toolbars, api) {
        if (isFocusRequested) {
            dispatch(focusDone(editorId));
        }
        api.focusEditor(); // auto focus the editor because we always use lazyload and that will steal the click
    }, [isFocusRequested, dispatch, editorId]);
}
//# sourceMappingURL=useCommentDaEditorReadyHandler.js.map